<template>
  <div class="sm:py-20">
    <div v-if="feedback" class="px-4 mx-auto max-w-4xl">
      <div class="overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
        <div class="p-6">
          <div class="flex justify-between items-center mb-6">
            <h1 class="text-2xl font-bold text-gray-800 dark:text-white">{{ feedback.name }}</h1>
            <div class="text-sm text-gray-500 dark:text-gray-400">
              {{ formatDate(feedback.created_at) }}
            </div>
          </div>

          <div class="mb-6">
            <div class="mb-2 text-gray-600 dark:text-gray-300">Email:</div>
            <div class="px-4 py-2 text-sm bg-gray-100 rounded-lg dark:bg-gray-700 dark:text-white">
              {{ feedback.email }}
            </div>
          </div>

          <div>
            <div class="mb-2 text-gray-600 dark:text-gray-300">Message:</div>
            <div class="p-4 text-gray-800 bg-gray-100 rounded-lg dark:bg-gray-700 dark:text-gray-200">
              {{ feedback.message }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex justify-center items-center h-screen">
      <div class="text-center">
        <div class="mx-auto mb-4 w-12 h-12 rounded-full border-b-2 border-gray-900 animate-spin dark:border-white"></div>
        <p class="text-gray-600 dark:text-gray-400">Loading feedback...</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useAdminStore } from '@/stores/adminStore';
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import { ROUTES } from '@/router/routeNames';
const route = useRoute();
const router = useRouter();
const adminStore = useAdminStore();
const { feedback } = storeToRefs(adminStore);

// Format date to be more readable
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

onMounted(() => {
  adminStore.fetchFeedback(route.params.id);
});
</script>

<style lang="scss" scoped>

</style>
